export default __webpack_public_path__ + "static/media/french-rose.9b3e87fb.png";